import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const associazionePage = gql`
  ${seoFragment}
  ${responsiveImageFragment}

  query AssociazionePage($locale: SiteLocale) {
    paginaAssociazione(locale: $locale) {
      seo {
        ...SeoFragment
      }
      titolo
      slug
      intro {
        titolo
        primaColonna
        secondaColonna
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        parolaTarget
        titolo
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      sezioneDoppiaColonna1 {
        id
        primaColonna
        secondaColonna
        sottotitolo
        titolo
        immagineDecorativa {
          titolo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
        parolaTarget
        cta {
          testo
          link
          file {
            url
          }
        }
      }
      preFooter {
        contenuto {
          titolo
          primaColonna
          secondaColonna
          immagineDecorativa {
            titolo
            immagine {
              responsiveImage(imgixParams: { fm: webp, q: "50" }) {
                ...ResponsiveImageFragment
              }
            }
          }
          cta {
            testo
            link
            file {
              url
            }
          }
        }
        coloreSfondo {
          hex
        }
      }
      carosello(locale: $locale) {
        titolo
        slug
        _allSlugLocales {
          value
          locale
        }
        landscape: cover {
          responsiveImage(imgixParams: { fm: webp, q: "50" }) {
            ...ResponsiveImageFragment
          }
        }
        portrait: cover {
          responsiveImage(
            imgixParams: { auto: compress, q: "50", ar: "1:1", fit: crop }
          ) {
            ...ResponsiveImageFragment
          }
        }
      }
    }
  }
`
